import {LocalStyleSheet} from '../../../utils/types'

export const styles: LocalStyleSheet = {
    navSearchWrapper: {
        display: 'flex',
        width: '100%',
        alignItems: 'center'
    },
    navSearch: {
        width: '100%'
    },
    navSearchIcon: {
        paddingRight: 10,
        paddingLeft: 10,
        color: 'inherit'
    },
    header: {
        paddingLeft: 92,
        height: 75,
        paddingRight: 62,
        display: 'flex'
    },
    menu: {
        paddingTop: 5,
        width: '100%',
        display: 'flex',
        alignItems: 'center'
    },
    menuItemNavSearch: {
        background: 'inherit',
        backgroundColor: 'inherit',
        cursor: 'inherit',
        width: '45%'
    },
    marginRightAuto: {
        marginRight: 'auto'
    },
    logo: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        marginRight: 11
    },
    // Matches the Attendant header logo (.dtb-logo, height 23)
    logoImage: {
        height: 23,
        width: 'auto',
        display: 'block'
    },
    // Matches the Attendant header subtitle (.dtb-header-subtitle)
    logoSubtitle: {
        marginTop: 2,
        fontSize: 12,
        fontWeight: 'bold',
        textTransform: 'uppercase',
        lineHeight: 1,
        whiteSpace: 'nowrap',
        color: '#d0e8f4'
    }
}
